<!-- IF PATRON IS LOGGED WITH OKTA, SHOW IT -->
<div class="w-100 flex box-white px-6 py-4 mb-3 flex-col gap-y-7 md:flex-row">
  <!-- ACCOUNT CREDIT COLUMN-->
  <div class="flex flex-col account-credit-col w-full md:w-1/2">
    <div class="title">Account Credit</div>
    <div class="sub-title mb-2 md:mb-5">
      <b
        >Your account’s available credit:
        {{ patron.accountCredit | currency: 'USD' : 'symbol' : '1.2-2' }}</b
      ><br />
      Please select the amount you would like to use:
    </div>
    <div
      class="w-full flex flex-col gap-y-2 items-baseline md:flex-row md:items-center">
      <div class="gap-x-3 flex mr-5 justify-center items-center w-full">
        <span class="flex justify-center items-center">$</span>
        <input
          type="text"
          value="0"
          class="selector-filter flex"
          (blur)="onBlurInputCredits()"
          [(ngModel)]="paymentDetails.accountCredit.credits" />
      </div>
      <div class="flex gap-x-4">
        <input
          type="checkbox"
          name="payInFull"
          [(ngModel)]="paymentDetails.accountCredit.payFull"
          (change)="onCheckboxPayInFullChange($event)" />
        <span>Use all available credit</span>
      </div>
    </div>
  </div>
  <!-- DIGITAL WALLET COLUMN-->
  <div class="flex flex-col digital-wallet-col w-full md:ml-10 md:w-1/2">
    <div class="title">Payment Options</div>
    <div class="sub-title mb-5">
      <b
        >Total amount due:
        {{
          transaction.transaction.tdcTransaction?.balance
            | currency: 'USD' : 'symbol' : '1.2-2'
        }}</b
      >
      <br />
      Credit applied:
      {{ showCreditsApplies | currency: 'USD' : 'symbol' : '1.2-2' }}
      <br />
      Remaining balance:
      {{ substractCreditsToBalance | currency: 'USD' : 'symbol' : '1.2-2' }}
      <br />
      Please select the digital wallet card you would like to use:
    </div>
    <div>
      <select
        [(ngModel)]="paymentDetails.digitalWallet"
        (change)="onChangeDigitalWalletSelector()"
        name="digitalWallet"
        class="selector-filter w-full">
        <option [ngValue]="null">Select your Digital wallet</option>
        @for (item of patron.digitalWalletList; track item.id) {
          <option [ngValue]="item">
            {{ item.nickname }}
          </option>
        }
      </select>
    </div>
  </div>
</div>
